import { ElLoading } from "element-plus";

export default class LoadingInstance {
  private static instance: LoadingInstance;
  private loadingInstance: any;

  private constructor() {
    // 创建 loading 实例的选项
    const options = {
      fullscreen: true,
    };
    // 创建 loading 实例
    this.loadingInstance = ElLoading.service(options);
  }

  public static getInstance(): LoadingInstance {
    if (!LoadingInstance.instance) {
      LoadingInstance.instance = new LoadingInstance();
    }
    return LoadingInstance.instance;
  }

  public hideLoading(): void {
    // 关闭 loading 动画
    this.loadingInstance?.close();
  }
}
